import Icon from 'components/Icon';
import { useTranslation } from 'services/hooks';

import './style.css';

const API_URL = process.env.REACT_APP_API_URL;

const CourseCard = ({ progress, title, thumbnail, recordId, isGuide, onClick, disabled, isInternalCourse, courseTypeId, ...restProps }) => {
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'personal_area';

	const CourseState = () => {
		if (progress <= 0)
			return (
				<div className="CourseCard__details__progress--not_started">
					{getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_course_state_not_started`)}
				</div>
			);
		else if (progress >= 100)
			return (
				<div className="CourseCard__details__progress--completed">
					{getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_course_state_completed`)}
				</div>
			);
		return (
			<div className="CourseCard__details__progress">
				{isInternalCourse
					? `${progress} % ${getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_progress_complete`)}`
					: getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_course_state_in_progress`)}
			</div>
		);
	};

	const IMAGE_URL = (API_URL + (thumbnail || '')).replace(/\\/g, '/');

	return (
		<div className="CourseCard" disabled={disabled}>
			<div className="CourseCard__thumbnail" style={{ background: `url(${IMAGE_URL}) no-repeat top left` }}></div>
			<div className="CourseCard__details" onClick={() => !disabled && onClick({ recordId, isInternalCourse, courseTypeId, ...restProps })}>
				<CourseState />
				<div className="CourseCard__details__title">{title}</div>
				<div className="CourseCard__details__link">
					{`${getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_course_details_link`)} ${
						isGuide
							? getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_course_details_link_guide`)
							: getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_course_details_link_course`)
					}`}
					<Icon icon="rightArrow" size="20" />
				</div>
			</div>
		</div>
	);
};

export default CourseCard;
